import { useVueData } from './useVueData';

export function useGitlabHostname(): string {
  const { gitlabGraphqlUrl } = useVueData();

  return new URL(gitlabGraphqlUrl).hostname;
}
